import React from 'react'
import DAppLayout from './layouts/DAppLayout'
import {Box, Button, Link, Text, useColorMode} from '@chakra-ui/react';
import {RaffleUserCreatorForm} from './components/RaffleUserCreatorForm';
import { navigateBack } from '../../utils/navigation';
import { BsArrowLeft } from 'react-icons/bs';
import { monetFeatureConfig } from '../../config/monetFeatureConfig';
import { FeatureDisabled } from './components/FeatureDisabled';
import { RaffleUserCreatorFormV2 } from './components/RaffleUserCreatorFormV2';

const DAppRaffleCreate = () => {
  const {colorMode} = useColorMode()
  const isDarkMode = colorMode === 'dark'

  return (
    <DAppLayout>
      <Box p={['0 .2rem']}>
        <Text
          fontSize={['1.5rem', '2rem']}
          fontWeight='600'
          lineHeight='1.5'
        >
          Create new NFT Raffle
        </Text>
        {monetFeatureConfig.raffleCreateUser ? <RaffleUserCreatorFormV2 /> : <FeatureDisabled/>}
      </Box>
    </DAppLayout>
  )
}

export default DAppRaffleCreate
